import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import '@/index.css'
import { registerSessionPort } from '@/api/registerSessionPort'
import { startAccessSync } from '@/stores/accessSync'
import { clearLegacyStreamCaches } from '@/stores/legacyCacheCleanup'
import { App } from './App'

// Wire the transport's session port to the stores before anything can make a request.
registerSessionPort()

// Keep the cached access inputs in step with the two changes no request reports: the projects the
// user belongs to, which is the one quota counter derived from the auth user, and the active org,
// which decides whose billing status plan-gates the UI.
startAccessSync()

// Reclaim storage from superseded cache layouts. Best-effort, so it isn't awaited.
void clearLegacyStreamCaches()

createRoot(document.getElementById('root') as HTMLElement).render(
	<StrictMode>
		<App />
	</StrictMode>,
)
